import { render, staticRenderFns } from "./PartialChip.vue?vue&type=template&id=583c73d2&scoped=true&"
import script from "./PartialChip.vue?vue&type=script&lang=js&"
export * from "./PartialChip.vue?vue&type=script&lang=js&"
import style0 from "./PartialChip.vue?vue&type=style&index=0&id=583c73d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583c73d2",
  null
  
)

export default component.exports